import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';

export const useLogClickSearch = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_SEARCH',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
      },
    });
  }, [logGoodsAnalytics]);
};
